<div class="whats-next">
	<ul *ngIf="whatsNext?.length > 0">
		<li *ngFor="let next of whatsNext">
			<div class="image-text">
				<div>
					<img
						class="image-icon"
						src="/assets/img/icons/icon-tick-purple.png"
					/>
				</div>
				<div class="list-text" [innerHtml]="next"></div>
			</div>
		</li>
	</ul>
</div>
